/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchPropertyGeometryDto } from '../../models/search-property-geometry-dto';

export interface SearchForPropertyGeometryByPfiList$Params {
  pfi: Array<string>;
}

export function searchForPropertyGeometryByPfiList(
  http: HttpClient,
  rootUrl: string,
  params: SearchForPropertyGeometryByPfiList$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchPropertyGeometryDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    searchForPropertyGeometryByPfiList.PATH,
    'get',
  );
  if (params) {
    rb.query('pfi', params.pfi, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchPropertyGeometryDto>;
      }),
    );
}

searchForPropertyGeometryByPfiList.PATH = '/search/property/geometry';
